export default function Merch() {
  return (
    <div data-testid="merch-grid" className="max-w-2xl mx-auto py-24 sm:py-40 flex items-center justify-center">
      <span data-testid="merch-soon" className="text-[#5a5e65] text-xs sm:text-sm tracking-[0.35em]">COMING SOON</span>
    </div>
  );
}
